import { useQuery } from '@tanstack/react-query'

import { consulta, pedir } from './nucleo'

/**
 * Las direcciones publicadas de una web, con su título (`GET /api/seo/destinos`): para
 * elegir a dónde lleva una redirección en vez de escribir la ruta a mano. Solo lo
 * publicado: una redirección a un borrador sería otro 404.
 */
export type Destino = { ruta: string; titulo: string; tipo: 'entrada' | 'pagina' | 'producto' | 'servicio' }

export const useDestinos = (sitio: null | number) =>
  useQuery({
    queryKey: ['destinos', sitio],
    enabled: sitio !== null,
    queryFn: async () => (await pedir<{ destinos: Destino[] }>(`/seo/destinos${consulta({ sitio: sitio ?? undefined })}`)).destinos,
    staleTime: 60_000,
  })
